import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Box } from '@material-ui/core'

import { filterFalsyValues } from '~/core/helpers/helpers'
import useClientSearch from '~/customer/hooks/useClientSearch'
import useSalesQueryParams from '~/router/hooks/useQueryParams'
import SaleConfigurator from '~/sale/components/SaleConfigurator/SaleConfigurator'
import { selectTheme } from '~/ui/theme/store/theme.selectors'
import useTheme from '~/ui/theme/useTheme'

export default function SaleConfiguratorPage() {
  const { setTheme } = useTheme()
  const themeName = useSelector(selectTheme)
  const { brand, documentType, documentValue, contractId } = useSalesQueryParams()

  useClientSearch({
    brand,
    body: filterFalsyValues({ validationType: documentType, value: documentValue, contractId }),
  })

  useEffect(() => {
    if (brand) setTheme(brand)
  }, [brand])

  return (
    <Box
      maxWidth="920px"
      margin="0 auto"
      data-hook={`sale-configurator-page${brand ? `-${themeName}` : ''}`}
    >
      <SaleConfigurator />
    </Box>
  )
}
